module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "epigraph"
    }
  }, [_vm._v("He wasn’t really happy; he was only watching happiness from close to instead of from far away.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Graham Green,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("“The Basement Room”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d4b0a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4epigraph.vue
// module id = 78
// module chunks = 0